import React from 'react';
import { Datagrid, DateField, Filter, ReferenceInput, SelectInput, ShowButton, TextField, TextInput } from 'react-admin';
import TList from 'cw-core-admin-ui/src/components/wrapper/TList';
import { AmountField } from 'cw-core-admin-ui/src/components/fields';
import { invoiceVoucherStatusForSelection } from './InvoiceVoucherConstants';

const InvoiceVoucherFilter = (props) => (
	<Filter {...props}>
		<TextInput alwaysOn resettable source="amountFrom" label="resources.invoiceVouchers.filter.amountFrom" />
		<TextInput alwaysOn resettable source="amountTo" label="resources.invoiceVouchers.filter.amountTo" />
		<ReferenceInput alwaysOn source="currency" reference="currencies" label="resources.invoiceVouchers.filter.currency">
			<SelectInput optionText="id" resettable />
		</ReferenceInput>
		<TextInput resettable source="marketingActions" label="resources.invoiceVouchers.filter.marketingActions" />
		<SelectInput alwaysOn resettable source="voucherStates" label="resources.invoiceVouchers.filter.voucherStates" choices={invoiceVoucherStatusForSelection} />
	</Filter>
);

export default ({ invoiceVoucherStatusForSelection, ...props }) => (
	<TList exporter={false} {...props} filters={<InvoiceVoucherFilter />}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" label="resources.invoiceVouchers.fields.id" />
			<TextField source="code" label="resources.invoiceVouchers.fields.voucherCode" />
			<AmountField source="amount" label="resources.invoiceVouchers.fields.voucherAmount" />
			<TextField source="marketingAction" label="resources.invoiceVouchers.fields.marketingAction" />
			<TextField source="description" label="resources.invoiceVouchers.fields.description" />
			<DateField source="creationDateTime" showTime label="resources.invoiceVouchers.fields.creationDateTime" />
			<TextField source="status" label="resources.invoiceVouchers.fields.status" />
		</Datagrid>
	</TList>
);
